import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.5 1C1.77614 1 2 1.22386 2 1.5L2 10.5C2 10.7761 1.77614 11 1.5 11C1.22386 11 1 10.7761 1 10.5V1.5C1 1.22386 1.22386 1 1.5 1Z" fill="currentColor" />
      <path d="M4.70711 5.5L7.35355 2.85355C7.54882 2.65829 7.54882 2.34171 7.35355 2.14645C7.15829 1.95118 6.84171 1.95118 6.64645 2.14645L3.14645 5.64645C2.95118 5.84171 2.95118 6.15829 3.14645 6.35355L6.64645 9.85355C6.84171 10.0488 7.15829 10.0488 7.35355 9.85355C7.54882 9.65829 7.54881 9.34171 7.35355 9.14645L4.70711 6.5L10.5 6.5C10.7761 6.5 11 6.27614 11 6C11 5.72386 10.7761 5.5 10.5 5.5L4.70711 5.5Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.99992 1.33301C2.36811 1.33301 2.66659 1.63148 2.66659 1.99967L2.66659 13.9997C2.66659 14.3679 2.36811 14.6663 1.99992 14.6663C1.63173 14.6663 1.33325 14.3679 1.33325 13.9997V1.99967C1.33325 1.63148 1.63173 1.33301 1.99992 1.33301Z" fill="currentColor" />
      <path d="M6.27606 7.33301L9.80466 3.80441C10.065 3.54406 10.065 3.12195 9.80466 2.8616C9.54431 2.60125 9.1222 2.60125 8.86185 2.8616L4.19518 7.52827C3.93483 7.78862 3.93483 8.21073 4.19518 8.47108L8.86185 13.1377C9.1222 13.3981 9.54431 13.3981 9.80466 13.1377C10.065 12.8774 10.065 12.4553 9.80466 12.1949L6.27606 8.66634L13.9999 8.66634C14.3681 8.66634 14.6666 8.36786 14.6666 7.99967C14.6666 7.63148 14.3681 7.33301 13.9999 7.33301L6.27606 7.33301Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.50008 1.66699C2.96032 1.66699 3.33342 2.04009 3.33342 2.50033L3.33341 17.5003C3.33341 17.9606 2.96032 18.3337 2.50008 18.3337C2.03984 18.3337 1.66675 17.9606 1.66675 17.5003V2.50033C1.66675 2.04009 2.03984 1.66699 2.50008 1.66699Z" fill="currentColor" />
      <path d="M7.84526 9.16699L12.256 4.75625C12.5814 4.43081 12.5814 3.90317 12.256 3.57774C11.9306 3.2523 11.4029 3.2523 11.0775 3.57774L5.24416 9.41107C4.91872 9.73651 4.91872 10.2641 5.24416 10.5896L11.0775 16.4229C11.4029 16.7484 11.9306 16.7484 12.256 16.4229C12.5814 16.0975 12.5814 15.5698 12.256 15.2444L7.84526 10.8337H17.5001C17.9603 10.8337 18.3334 10.4606 18.3334 10.0003C18.3334 9.54009 17.9603 9.16699 17.5001 9.16699L7.84526 9.16699Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.5 1C1.77614 1 2 1.22386 2 1.5L2 10.5C2 10.7761 1.77614 11 1.5 11C1.22386 11 1 10.7761 1 10.5V1.5C1 1.22386 1.22386 1 1.5 1Z" fill="currentColor" />
      <path d="M4.70711 5.5L7.35355 2.85355C7.54882 2.65829 7.54882 2.34171 7.35355 2.14645C7.15829 1.95118 6.84171 1.95118 6.64645 2.14645L3.14645 5.64645C2.95118 5.84171 2.95118 6.15829 3.14645 6.35355L6.64645 9.85355C6.84171 10.0488 7.15829 10.0488 7.35355 9.85355C7.54882 9.65829 7.54881 9.34171 7.35355 9.14645L4.70711 6.5L10.5 6.5C10.7761 6.5 11 6.27614 11 6C11 5.72386 10.7761 5.5 10.5 5.5L4.70711 5.5Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.99992 1.33301C2.36811 1.33301 2.66659 1.63148 2.66659 1.99967L2.66659 13.9997C2.66659 14.3679 2.36811 14.6663 1.99992 14.6663C1.63173 14.6663 1.33325 14.3679 1.33325 13.9997V1.99967C1.33325 1.63148 1.63173 1.33301 1.99992 1.33301Z" fill="currentColor" />
      <path d="M6.27606 7.33301L9.80466 3.80441C10.065 3.54406 10.065 3.12195 9.80466 2.8616C9.54431 2.60125 9.1222 2.60125 8.86185 2.8616L4.19518 7.52827C3.93483 7.78862 3.93483 8.21073 4.19518 8.47108L8.86185 13.1377C9.1222 13.3981 9.54431 13.3981 9.80466 13.1377C10.065 12.8774 10.065 12.4553 9.80466 12.1949L6.27606 8.66634L13.9999 8.66634C14.3681 8.66634 14.6666 8.36786 14.6666 7.99967C14.6666 7.63148 14.3681 7.33301 13.9999 7.33301L6.27606 7.33301Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.50008 1.66699C2.96032 1.66699 3.33342 2.04009 3.33342 2.50033L3.33341 17.5003C3.33341 17.9606 2.96032 18.3337 2.50008 18.3337C2.03984 18.3337 1.66675 17.9606 1.66675 17.5003V2.50033C1.66675 2.04009 2.03984 1.66699 2.50008 1.66699Z" fill="currentColor" />
      <path d="M7.84526 9.16699L12.256 4.75625C12.5814 4.43081 12.5814 3.90317 12.256 3.57774C11.9306 3.2523 11.4029 3.2523 11.0775 3.57774L5.24416 9.41107C4.91872 9.73651 4.91872 10.2641 5.24416 10.5896L11.0775 16.4229C11.4029 16.7484 11.9306 16.7484 12.256 16.4229C12.5814 16.0975 12.5814 15.5698 12.256 15.2444L7.84526 10.8337H17.5001C17.9603 10.8337 18.3334 10.4606 18.3334 10.0003C18.3334 9.54009 17.9603 9.16699 17.5001 9.16699L7.84526 9.16699Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconFirstPage: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"first-page"} {...props} />
);
